import { createTheme as createTheme$1 } from '@material-ui/core/styles';
import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { createBaseThemeOptions } from '../base/createBaseThemeOptions.esm.js';
import { defaultComponentThemes } from '../v5/defaultComponentThemes.esm.js';
import { transformV5ComponentThemesToV4 } from './overrides.esm.js';

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  member.set(obj, value);
  return value;
};
var _themes;
class UnifiedThemeHolder {
  constructor(v4, v5) {
    __privateAdd(this, _themes, /* @__PURE__ */ new Map());
    __privateSet(this, _themes, /* @__PURE__ */ new Map());
    if (v4) {
      __privateGet(this, _themes).set("v4", v4);
    }
    if (v5) {
      __privateGet(this, _themes).set("v5", v5);
    }
  }
  getTheme(version) {
    return __privateGet(this, _themes).get(version);
  }
}
_themes = new WeakMap();
function createUnifiedTheme(options) {
  const themeOptions = createBaseThemeOptions(options);
  const components = { ...defaultComponentThemes, ...options.components };
  const v5Theme = createTheme({ ...themeOptions, components });
  const v4Overrides = transformV5ComponentThemesToV4(v5Theme, components);
  const v4Theme = { ...createTheme$1(themeOptions), ...v4Overrides };
  return new UnifiedThemeHolder(v4Theme, v5Theme);
}
function createUnifiedThemeFromV4(options) {
  const v5Theme = adaptV4Theme(options);
  const v4Theme = createTheme$1(options);
  return new UnifiedThemeHolder(v4Theme, createTheme(v5Theme));
}

export { UnifiedThemeHolder, createUnifiedTheme, createUnifiedThemeFromV4 };
//# sourceMappingURL=UnifiedTheme.esm.js.map
